import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import {
  GroupBody,
  GroupHeader,
  GroupTitle,
  IconContainerV2,
  OptionText,
  TierControlItemV1,
} from './styled-components'

type TierOption = {
  text: string
  checked: boolean
}

type TierProduct = {
  key: string
  title: string
  disabled?: boolean
  options: Array<TierOption>
}

type Props = {
  product: TierProduct
}

const productIcons = {
  early: AcornsIcon.Icon.ProductEarly,
  invest: AcornsIcon.Icon.ProductInvestFv,
  later: AcornsIcon.Icon.ProductEarn,
  spend: AcornsIcon.Icon.ProductBankingFv,
}

export function renderProducts(tierProducts: TierProduct[]) {
  return tierProducts.map(tierProduct => {
    return <TierProductComponentV1 product={tierProduct} key={tierProduct.key} />
  })
}

const TierProductComponentV1 = ({ product }: Props) => {
  const productKey = product.key
  const productIcon = productIcons[productKey]
  const productTitle = product.title
  const options = product.options

  return (
    <TierControlItemV1>
      <GroupHeader>
        <GroupTitle disabled={product.disabled}>
          {productIcon && <AcornsIcon icon={productIcon} width="20px" height="20px" />}
          {productTitle}
        </GroupTitle>
        {!product.disabled && (
          <AcornsIcon icon={AcornsIcon.Icon.CheckmarkGreenNarrow} width="22px" height="22px" />
        )}
      </GroupHeader>
      <GroupBody>
        {options.map(({ text, checked }, i) => (
          <OptionText key={`option-${i}`} disabled={!checked}>
            <IconContainerV2>
              {checked ? (
                <AcornsIcon icon={AcornsIcon.Icon.CheckmarkFv} width="16px" height="16px" />
              ) : (
                <AcornsIcon icon={AcornsIcon.Icon.InlineClose} width="12px" height="12px" />
              )}
            </IconContainerV2>
            <span>{text}</span>
          </OptionText>
        ))}
      </GroupBody>
    </TierControlItemV1>
  )
}
